import { showNotification } from '@mantine/notifications';

export const notificationHandler = (): {
  successNotification: (successTitle: React.ReactNode, successMessage?: React.ReactNode) => void;
  errorNotification: (errorTitle: React.ReactNode, errorMessage?: React.ReactNode) => void;
  infoNotification: (
    infoTitle: React.ReactNode,
    infoMessage?: React.ReactNode,
    autoClose?: number | false,
  ) => void;
} => {
  const successNotification = (successTitle: React.ReactNode, successMessage?: React.ReactNode): void => {
    showNotification({
      title: successTitle,
      message: successMessage || '',
      color: 'teal',
      autoClose: 5000,
      closeButtonProps: {
        'data-cy': 'notificationCloseBtn',
      },
    });
  };

  const errorNotification = (errorTitle: React.ReactNode, errorMessage?: React.ReactNode): void => {
    showNotification({
      title: errorTitle,
      message:
        errorMessage ||
        `Something went wrong, please try again. Contact Support ref: ${Math.floor(Date.now() / 1000)}.`,
      color: 'red',
      autoClose: 5000,
      closeButtonProps: {
        'data-cy': 'notificationCloseBtn',
      },
    });
  };

  const infoNotification = (
    infoTitle: React.ReactNode,
    infoMessage?: React.ReactNode,
    autoClose: number | false = 5000,
  ): void => {
    showNotification({
      title: infoTitle,
      message: infoMessage || '',
      color: 'yellow',
      autoClose,
      closeButtonProps: {
        'data-cy': 'notificationCloseBtn',
      },
    });
  };
  return { successNotification, errorNotification, infoNotification };
};

export default notificationHandler;
